import React from 'react';
import { withTranslation } from 'react-i18next';
import helper from '../../../../utils/helper';
import Datagrid from '../../../UI/Datagrid';
import Backend from '../../../Layouts/Backend';
import { Alert, Button, Dropdown } from '../../../UI/Common';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../UI/ReactSelect';

const BatchReportsPage = (props) => {
  //prettier-ignore
  const { t, departments, batchReports, datagridProps, errors, isFetchingReport } = props;
  const history = useHistory();
  const [dept, setDept] = React.useState({
    id: undefined,
  });
  const [invalid, setInvalid] = React.useState('');
  const [batchIds, setBatchIds] = React.useState([]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setBatchIds([...batchIds, row.id]);
    } else {
      setBatchIds(batchIds.filter((x) => x !== row.id));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      setBatchIds(ids);
    } else {
      setBatchIds([]);
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: batchIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  React.useEffect(() => {
    const { deptId } = helper.getUserDepartment(departments);
    setDept({
      id: deptId,
    });
  }, [departments.length]);
  React.useEffect(() => {
    if (dept.id !== undefined) {
      props.onChangeDept(dept.id);
    }
  }, [dept]);
  function onGetReport(format) {
    setInvalid('');
    if (batchIds.length === 1) {
      props.onGetReport(batchIds[0], format);
    } else {
      setInvalid('Please choose only one batch report');
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <ReactSelect
          containerStyle={{ width: '30%' }}
          isClearable={false}
          label="Department"
          options={departments}
          value={dept.id}
          onChange={({ value }) => setDept({ id: value })}
          valueKey="id"
          labelKey="name"
        />
        <Button
          id="new-batch-report-btn"
          classes="mb-15"
          onClick={() =>
            history.push(
              `/reports/batch-reports/new-batch-report?deptId=${dept.id}`,
            )
          }
        >
          <i className="md-icon">add</i>
          {t('New Batch Number')}
        </Button>
        <Datagrid
          datagridProps={{
            keyField: 'id',
            data: batchReports,
            loading: props.isFetching,
            selectRow,
            ...datagridProps,
          }}
          ctxMenuOptions={props.ctxMenuOptions}
          exportProps={{
            fileName: 'BatchReports',
          }}
        />
        <div className="mt-10">
          <Alert.Error text={invalid} />
        </div>
        <div className="mt-10">
          <Button
            id="pdf-export"
            classes="mr-20"
            loading={isFetchingReport}
            onClick={() => onGetReport('pdf')}
          >
            {t('PDF')}
          </Button>
          <Button
            id="excel-export"
            classes="mr-20"
            loading={isFetchingReport}
            onClick={() => onGetReport('excel')}
          >
            {t('Excel')}
          </Button>
          <Button
            id="word-export"
            loading={isFetchingReport}
            onClick={() => onGetReport('word')}
          >
            {t('Word')}
          </Button>
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(BatchReportsPage);
